<template>
  <!-- CONTAINER DE CARD SIMPLES PARA CUSTOMIZAR - toolbar - content - actions -->
  <v-container fluid pa-5>
    <v-row justify="center" align="center" style="height:95vh">
      <v-col cols="12" xs="12" sm="7" md="6" lg="4" class="lighten-2 fill-height d-flex flex-column justify-center align-center">
        <v-card flat :color="card_color" min-width="95%" class="pa-0">
          <v-card-title :class="['d-flex justify-center', logo_class]" style="background-color: rgba(0,0,0,0.5);height: 30vh;z-index: 9999999;">
            <v-img src="@/assets/4ARTS_AZUL_E_BRANCO.png" class="logo" max-height="146" max-width="200">  </v-img>
          </v-card-title>
          <!-- <v-toolbar color="primary" dark flat>
            <v-toolbar-title></v-toolbar-title>
            <v-spacer />
          </v-toolbar> -->
          <div style="background-color: #fff;">
            <v-card-text class="login_content py-10 px-6">
              <!-- Slot para template de form - contents -->
              <slot name="form"></slot>
            </v-card-text>
            <!-- <v-card-actions> -->
            <v-col cols="12" class="card_buttons pa-3">
              <slot name="control"></slot>
            </v-col>
            <!-- </v-card-actions> -->
          </div>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
export default {
  props: {
    title: {
      type: String
    },
    card_color: {
      type: String,
      default: 'transparent'
    },
    logo_class: {
      type: String,
    }
  }
};
</script>
<style>
.login_content{
  background-color: #fff;
  border-radius: 5px;
  width: 80%;
  margin: auto;
  position: relative;
  top: -30px;
  box-shadow: 3px 7px 18px -8px rgba(0,0,0,0.52);
}
.card_buttons{
  position: relative;
  top: -70px;
}
</style>
